import BigNumber from 'bignumber.js';

import { AnalyticsApi, mainApi, queryFnNotifyWrapper } from 'modules/api';
import { captureError } from 'modules/api/captureError';
import { RangeSelectorType } from 'modules/api/const';
import { DECIMALS_RATIO } from 'modules/common';
import { t } from 'modules/i18n';
import { stakeCacheTags } from 'modules/stake/stakeCacheTags';

export type IRatioChartData = {
  ratio: BigNumber;
  timestamp: number;
}[];

export const EMPTY_RATIO_CHART_DATA: IRatioChartData = [];

export const { useGetRatioChartDataQuery } = mainApi.injectEndpoints({
  endpoints: build => ({
    getRatioChartData: build.query<IRatioChartData, RangeSelectorType>({
      queryFn: queryFnNotifyWrapper<RangeSelectorType, void, IRatioChartData>(
        async period => {
          const api = AnalyticsApi.getInstance();
          const data = await api.getRatioChartData(period);

          return {
            data: data.map(item => ({
              ratio: new BigNumber(item.ratio).div(DECIMALS_RATIO),
              timestamp: item.timestamp,
            })),
          };
        },
        error => {
          const message = t('notification.failedRatioChartData');
          captureError(error, message);

          return message;
        },
      ),
      providesTags: [stakeCacheTags.getBalances],
    }),
  }),
});
